import React from 'react'
import AddUserForm from '../../component/form/user/AddUserForm'

export default function AddUser() {
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                      
                        <AddUserForm />
                    </div>
                </div>
            </div>
        </>
    )
}
